import React, {Component } from 'react';
import { Layout, Menu, Dropdown , notification, Badge, Spin, Form,   Modal,Input,Divider,Button,Empty } from 'antd';
import {Row, Col} from 'react-bootstrap';
import {
    DesktopOutlined,
    PieChartOutlined,
    FilePdfOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    BellTwoTone,
} from '@ant-design/icons';
import mHelper from './config/Helper';
import {Link} from 'react-router-dom';
import LogoADportal from '../assets/LogoADportal.png'
import LogoADportalMini from '../assets/LogoADportalMini.png'
import imgProfil from '../assets/profil.png'
import mDashboardControllers from './control/dashboard/index.controllers';
import UIfx from 'uifx';
import tickAudio from './../assets/audio/point-blank.mp3';
import {io} from "socket.io-client";
// import './../index.css';

// const ENDPOINT_SOEKET = mHelper.URL_API_SERVER()+"/notification";
// const socket = socketIOClient(ENDPOINT_SOEKET);


const tick = new UIfx(
    tickAudio,
    {
      volume: 1, // value must be between 0.0 ⇔ 1.0
      throttleMs: 50
    }
)


const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
};

var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

// var socket = io(mHelper.URL_API_SERVER(), {
//     path: "/notification",
//     query: "token=" + isLogin.token_notif
// });

var socket = null;

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

var formChangePassword = React.createRef();

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            styleCollapsed : {marginLeft:256, transition:"all 0.2s"},
            notificationData : [],
            countNotification : 0,
            modalChangePassword : false,
            loadingChangePassword : false,
            timeCount : 0
        } 

        if(!isLogin){
            document.location.href=`${process.env.PUBLIC_URL}/login`;
        }
    }
    
    startAudio = () => {
        tick.play();
    }

    async componentDidMount() {
        
        if(isLogin){
            socket = io(mHelper.URL_API_SERVER(), {
                path: "/notification",
                transportOptions: {
                polling: {
                    extraHeaders: {
                    'Authorization': 'Bearer 33!894bHncvbGFTY_op0@dfgUY_dFcBnfhuOP',
                    },
                },
                },
            });
            socket.on("connect", () => {
                socket.on('notification_app',  (msg) => { 
                    var placement  ='bottomRight';
                    if(msg.to === isLogin.company.ad_code){
                        notification.info({
                            message: msg.subject,
                            description:msg.body,
                            placement,
                        });
                        this.startAudio();
                    }
                    this.onUpdateNotification();
                });
            });
            this.onUpdateNotification();
        }
        this.setState({timeCount:0});
        var no = 0;
        setInterval(()=>{ 
            if(no >= 3600){
                this.SIGN_OUT();
            }
            if((no % 20) === 0){
                mHelper.CHECk_PING((r)=>{
                    if(r.error !== undefined){
                        if(r.error.statusCode === 401){
                            this.SIGN_OUT();
                        }
                    }
                });
            }
            no++;
        }, 1000);
    }



    onUpdateNotification = () =>{
        var filterNotif = {order:["id DESC"], where : {and:[{types : "NOTIFICATION"},{app : "DIGIPOS"},{to:isLogin.company.ad_code},{at_flag:0},/*{code : {inq : notiveACC}}*/]}};
        mDashboardControllers.GET_NOTIFICATION(filterNotif,(r)=>{
            if(r.error !== undefined){
                // mHelper.DEL_COOKIES("login");
                this.SIGN_OUT();
                document.location.href=`${process.env.PUBLIC_URL}/login`;
                return;
            }
            // console.log("NOTIFICATION",r);
            this.setState({countNotification : r.length, notificationData : r});
        });
    }

    onReadNotif = (id) =>{
        mDashboardControllers.READ_NOTIFICATION(id,(r)=>{
            // console.log(r);
            if(r.success === true){
                switch(r.type){
                    case "DOWNLOAD_AD_A" :
                        // document.location.href="/invoice/upload"
                        break;
                    default :
                    break;
                }
               
            }
            this.onUpdateNotification();
        })
    }

    SIGN_OUT = () =>{
        mDashboardControllers.LOGOUT_TOKEN(isLogin.token,(r)=>{
            mHelper.SIGN_OUT((rToken)=>{
                document.location.href="/";
            });
        });
    }
    

    onCollapse = collapsed => {
        if(collapsed === false){
            this.setState({ collapsed ,  styleCollapsed : {marginLeft:256, transition:"all 0.2s" } });
            // useAudio(true);
        }else{
            this.setState({ collapsed ,  styleCollapsed : {marginLeft:80, transition:"all 0.2s" }});
            // useAudio(false);
        }
    };

    toggle = () => {
        this.setState({
          collapsed: !this.state.collapsed,
        });
        if(this.state.collapsed === false){
            this.setState({ styleCollapsed : {marginLeft:80, transition:"all 0.2s"}});
        }else{
            this.setState({ styleCollapsed : {marginLeft:256}, transition:"all 0.2s" });
        }
        
        this.startAudio();
    };

    onOpenChangePassword = () => {
        this.setState({ modalChangePassword : true});
        setTimeout(()=>{
            formChangePassword.current.resetFields();
        },2000);
    }

    onFinishChangePassword = (values) => {
        // console.log(values);
        mDashboardControllers.CHANGE_PASSWORD(values.old_pass , values.new_pass, values.confirm_pass , (r) => {
            // console.log(r);
            if(r.success === false){
                Modal.info({
                    title: 'Error',
                    content: (
                      <div>
                        <p>{r.message}</p>
                      </div>
                    ),
                    onOk() {},
                });
                return;
            }
            mHelper.SIGN_OUT((r)=>{
                document.location.href = "";
            })
        });
    }

    onCancelFormChangePassword = () =>{
        this.setState({ modalChangePassword : false});
        // document.location.href="";
        // e.preventDefault()
    }
    
    menu = () => {
        return (
            <Menu>
                <div className="menu-notif">
                    {
                        
                        this.state.notificationData.length === 0 ? <Empty description="No Notification"></Empty> : 
                        this.state.notificationData.map((item,index)=>{
                            
                            return (
                                <Link  to="#"  key={index} onClick={(e) => { this.onReadNotif(item.id)}}>
                                    <Row className="notif_content" >
                                        <Col className="notif_title" sm={12}  lg={12}>{item.subject}</Col>
                                        <Col className="notif_body" sm={12}  lg={12}>{item.body}</Col>
                                        <Col sm={12}  lg={12} style={{textAlign:"right",fontSize:10}}>{mHelper.CONVERT_CURRENTTIMES(parseInt(item.at_create))}</Col>
                                    </Row>
                                </Link>
                            );
                        })
                    }
                </div>
            </Menu>
        )
    }

    menuProfile = () => {
        return (
            <Menu>
                <Menu.Item key="9" onClick={(e) =>{this.onOpenChangePassword()}} > Change Password</Menu.Item>
                <Menu.Item key="10" onClick={(e) =>{this.SIGN_OUT()}}>Logout</Menu.Item>
            </Menu>
        )
    }

    onNotifSoundLoading = (e) => {
        // console.log(e);
    }

    onNotifSoundPlaying = (e) => {
        // console.log(e);
    }

    onNotifSoundFinished = (e) => {
        // console.log(e);
    }

    render(){
       

        let user = JSON.parse(mHelper.GET_COOKIES('login_portal'))
        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Sider  width={256} className="menu-page-right"
                style={{ overflow: 'auto', height: '100vh',  position:"fixed", width:"100%" }} trigger={null} collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
                    {/* <div className="logo">
                    </div> */}
                    <Menu theme="light" defaultSelectedKeys={['1']} mode="inline">
                        <div className="newLogo">
                            <img alt='' src={ this.state.collapsed ? LogoADportalMini : LogoADportal } style={{
                                transition: '0.5s',
                                width: this.state.collapsed ? "80px" : "240px"   ,
                                marginTop:30,
                                marginBottom:30,
                                marginLeft:10,
                                marginRight:10
                            }}></img>
                        </div>
                        <Menu.Item key="1" icon={<PieChartOutlined />}>
                            <Link to="/dashboard" > Dashboard </Link>
                        </Menu.Item>
                        <SubMenu key="sub1" icon={<DesktopOutlined />} title="Form Input">
                            <Menu.Item key="2"><Link to="/invoice/upload">Invoice & Upload</Link></Menu.Item>
                            <Menu.Item key="3" ><Link to="/nota/upload">Nota Debet & Upload</Link></Menu.Item>
                            <Menu.Item key="4"><Link to="/dispute/upload" >Dispute & Upload</Link></Menu.Item>
                            {/* <Menu.Item key="5">Revisi Doc Upload</Menu.Item> */}
                        </SubMenu>
                        <SubMenu key="sub2" icon={<FilePdfOutlined />} title="File Download">
                            <Menu.Item key="6"><Link to="/download/doc-a" >Document AD A</Link></Menu.Item>
                            <Menu.Item key="7"><Link to="/download/doc-b" >Document AD B</Link></Menu.Item>
                        </SubMenu>
                    </Menu>
                </Sider>
                <Layout className="site-layout" style={{backgroundColor : '#E3EAFF'}}>
                {/* <Header className="site-layout-background" style={{ padding: 0 }} /> */}
                <Header className="site-layout-background header-page" style={{ padding: 0, position:"fixed", backgroundColor: '#e20002' , width:"100%", marginLeft : this.state.styleCollapsed.marginLeft, transition :this.state.styleCollapsed.transition }}>
                    {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, { className: 'trigger', onClick: this.toggle})}
                    <Row style={{ padding: 0, position:"fixed", right:0, paddingRight : 20, marginRight: '20px'}}>
                        <Col className="justify-content-end" >
                            <Dropdown overlay={this.menu} trigger={['click']} arrow={true   }>
                                <Link to="#" className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                    <Badge count={this.state.countNotification} overflowCount={99}>
                                        <span className="head-example" >
                                        <BellTwoTone style={{fontSize: '18px'}} twoToneColor="white"/>
                                        </span >
                                    </Badge>
                                </Link >
                            </Dropdown>
                        </Col>
                        <Dropdown overlay={this.menuProfile} trigger={['click']} arrow={true   }>
                            <Link  to="#" className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                <span  to="#" className="head-example" >
                                    <div className="profil" style={{marginLeft: '20px'}}>
                                        <div className="image">
                                            <img alt='' src={imgProfil}></img>
                                        </div>
                                        <p style={{ fontSize: "13px", margin: "0", color: 'white' }}>&nbsp; Halo, <b>{user.name}</b></p>
                                    </div>
                                </span >
                            </Link >
                        </Dropdown>
                    </Row>
                </Header>
                <Content style={{marginTop:100, marginRight:20, marginLeft : this.state.styleCollapsed.marginLeft+20, transition :this.state.styleCollapsed.transition }} >
                    {this.props.children}
                </Content>
                <Footer style={{marginLeft : this.state.styleCollapsed.marginLeft+20, transition :this.state.styleCollapsed.transition, textAlign: 'center', backgroundColor: '#E3EAFF' }}>IT Developer ©2020 Created by <Link  to="#">Link Aja</Link ></Footer>
                </Layout>

                <Modal
                    width="500px"
                    title="Change Password"
                    visible={this.state.modalChangePassword}
                    footer={null}
                    onCancel={this.onCancelFormChangePassword}>
                        
                    <Spin spinning={this.state.loadingChangePassword} >
                        <Form {...layout}   ref={formChangePassword}  name="configForm" onFinish={this.onFinishChangePassword}>
                            <Form.Item name="old_pass"  
                                rules={[
                                    {
                                    required: true, message: 'Please input Old Password  !',
                                    },
                                    { min: 8, message: 'Password must be minimum 8 characters.' }
                                ]}
                                label="Old Password">
                                <Input.Password  placeholder="" />
                            </Form.Item>
                            <Form.Item name="new_pass"  
                                rules={[
                                    {
                                    required: true, message: 'Please input New Password  !',
                                    },
                                    { min: 8, message: 'Password must be minimum 8 characters.' }
                                ]}
                                label="New Password">
                                <Input.Password  placeholder="" />
                            </Form.Item>
                            <Form.Item name="confirm_pass"  
                                rules={[
                                    {
                                    required: true, message: 'Please input Confirm Password  !',
                                    },
                                    { min: 8, message: 'Password must be minimum 8 characters.' }
                                ]}
                                label="Confirm Password">
                                <Input.Password  placeholder="" />
                            </Form.Item>
                            <Divider />
                            <div style={{textAlign: 'right'}}>
                                <Button className="primaryButton" htmlType="submit" >
                                    Change Password
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </Modal>
            </Layout>
            
            
            
    
        )
    }
}
export default App

